export default __webpack_public_path__ + "static/media/proj1_3.e899eb49.jpg";